import React, { Component } from 'react';
import { InputGroup, InputGroupAddon, Input, Button, Label, Form, Spinner, Table, FormText, FormFeedback } from 'reactstrap';
import axios from 'axios';
import './Checker.css';
import ReactGA from 'react-ga';

const isUrlValid = require('url-validation');

class Checker extends Component {
    state = {
        inputurl: '',
        isLoading: false,
        tags: [],
        inputerror: false,
        tagresult: false,
        outputerror: ''
    }

    toggle = () => {
        this.setState({
            isLoading: !this.state.isLoading
        });
    }

    onChange = (e) => {
        this.setState({
            inputurl: e.target.value,
            inputerror: false
        });
    }

    onSubmit = (e) => {
        e.preventDefault();

        if ( isUrlValid(this.state.inputurl) ){
            this.setState({
                isLoading: true,
                inputurl: '',
                tags: [],
                tagresult: false,
                outputerror: ''
            });
            ReactGA.event({
                category: 'User',
                action: 'Searched for URL',
                label: this.state.inputurl
            });
            const urlobject = {
                url: this.state.inputurl
            }
            axios
                // .post('http://localhost:5000/api/tags/', urlobject)
                .post('/api/tags/', urlobject)
                .then(res => 
                    this.setState({
                        tags: res.data,
                        tagresult: true
                    }))
                .catch(err =>                     
                    this.setState({
                        outputerror: "Error: too many requests!"
                    }))
                .then(() =>
                    this.setState({
                        isLoading: false
                    })
                );

        } else {
            this.setState({
                inputerror: true
            });
        }
    }

    render(){
        
        const tagcounter = (
            <p className="tag-counter">{this.state.tags.length} tag(s) found!</p>
        );

        const taglist = (
            this.state.tags.map(item => {
                return (
                    <tr key={item.intid}>
                        <td className="tld-column">{item.tld}</td>
                        <td className="status-column">{item.status}</td>
                        <td className="type-column">{item.resourcetype}</td>
                        <td className="url-column">{item.url}</td>
                     </tr> 
                )
            })
        )
        
        return(
        <div className="checker-div">
            <Form onSubmit={this.onSubmit}>  
                <Label className="checker-label">Enter a <b>valid</b> URL (begins with <b>http</b> or <b>https)</b>:</Label>
                <InputGroup className="checker-input">
                    <Input 
                        placeholder="" 
                        onChange={this.onChange}
                        value={this.state.inputurl}
                        invalid={ this.state.inputerror }
                    />
                    <InputGroupAddon addonType="append">
                        <Button><span role="img" aria-label="Inspect">🔍</span> Inspect</Button>
                    </InputGroupAddon>
                </InputGroup>
                <FormFeedback>
                Please input a valid URL (e.g. "https://google.com")
                </FormFeedback>
                <FormText color="muted" className="checker-input-caption">
                    Please wait 60 seconds before consecutive queries
                </FormText>
            </Form>
            
            {this.state.isLoading ? (

             <div className="spinner-div">
                    <Spinner color="primary" className="checker-spinner" />
                    <p>Checking URL (please wait a few seconds)</p>
             </div>

            ) : (<div></div>)}

            {this.state.outputerror.length ? (

            <div className="error-message">
                <p>{this.state.outputerror}</p>
            </div>

            ) : (<div></div>)}

            {this.state.tagresult ? (<div>{tagcounter}</div>) : (<div></div>)}

            {this.state.tags.length ? (
                <div> 
                    <Table size="sm" bordered className="tagtable">
                        <thead>
                        <tr>
                            <th>Domain</th>
                            <th>Code</th>
                            <th>Type</th>
                            <th>URL</th>
                        </tr>
                        </thead>
                        <tbody>
                            {taglist}
                        </tbody>
                    </Table>
                   
                </div>) 
            
            : (<div></div>)}


        </div>

        );
    }
}

export default Checker;